import { contactEmail, discoveryNote, hourlyRate, location } from '../data/contact';
import './Contact.scss';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container contact__layout">
        <div className="contact__card">
          <span className="section-eyebrow">Contact</span>
          <h2 className="section-title">Ready to start?</h2>
          <p className="contact__rate">Project rate: {hourlyRate}</p>
          <p className="contact__note">{discoveryNote}</p>
          <a className="cta-button" href={`mailto:${contactEmail}`}>
            Email {contactEmail}
          </a>
        </div>
        <div className="contact__details">
          <div>
            <h3>Location</h3>
            <p>{location} · working with clients locally and online</p>
          </div>
          <div>
            <h3>Engagement basics</h3>
            <ul>
              <li>Signed NDA available for sensitive research.</li>
              <li>Remote collaboration with weekly build reports.</li>
              <li>Shop visits welcomed by appointment.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
